import React, { Component } from 'react';
import { Menu, Card, message, Empty } from 'antd';
import axios from "axios";
import moment from "moment";
import './medicalReport.scss';
import { requestErrorLog } from "@/common/util";

class MedicalReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLeft: false,
      patientInfo: "",
      menuData: "",
      selectedKeys: { key: "" }
    }
  }

  componentDidMount() {
    this.patientInfo()
  }

  patientInfo = () => {
    var url = window.location.href;
    var searchId = this.getCaption(url, "=");
    let params={
      Token: null,
      Command: "E00108",
      Param: {
        Type: "PatientInfo", // 患者信息
        EXAM_UID: searchId
      },
      RequestModel: null
    }
    axios.post(window.g.baseURL + "/api/websiteecg", params).then((res) => {
      if (res.data.Status === 1) {
        const infoData = res.data.Result.patientinfo
        const examItem = res.data.Result.exam_item
        infoData.forEach(info => {
          this.setState({
            patientInfo: info,
          })
        });
        const { selectedKeys } = this.state
        selectedKeys.key = examItem && examItem[0] ? examItem[0].EXAM_UID : ""
        this.selectMenu(selectedKeys)
        this.setState({
          menuData: examItem
        })
      } else {
        message.error(res.data.Msg);
      }
    }).catch(err => {
      requestErrorLog('', '登录请求医院列表报错:'+JSON.stringify(params), 0, false)
    });
  }

  selectMenu = (item) => {
    const { selectedKeys } = this.state
    selectedKeys.key = item.key
    let params={
      Token: null,
      Command: "E00108",
      Param: {
        Type: "ExamimageInfo", // 检查项目诊断图像
        EXAM_UID: selectedKeys.key
      },
      RequestModel: null
    }
    axios.post(window.g.baseURL + "/api/websiteecg",params ).then((res) => {
      if (res.data.Status === 1) {
        const imagesPath = res.data.Result ? res.data.Result : "null"
        const images = window.g.baseURL + "/" + imagesPath.path
        this.setState({
          imageUrl: images,
        })
      } else {
        message.error(res.data.Msg);
      }
    }).catch(err => {
      requestErrorLog('', '登录请求医院列表报错:'+JSON.stringify(params), 0, false)
    });
  }


  /**
  * 截取指定字符后的内容
  */
  getCaption(url, parameter) {
    var index = url.lastIndexOf(parameter);
    url = url.substring(index + 1, url.length);
    return url;
  }

  render() {
    const { menuData, selectedKeys, patientInfo, imageUrl } = this.state;

    var dataTime = moment(menuData.EXAM_DATETIME ? menuData.EXAM_DATETIME : undefined).format('YYYY-MM-DD')
    return (
      <div style={{ width: '100%', height: '100%', overflow: 'hidden', background: '#f4f4f4' }}>
        <div className="medicalReporttWrap" style={{ width: '95%', margin: 'auto', height: '100%', over: 'auto' }}>
          <div className="reportLeft">
            <Card className="doubleBox paddingB textPadd" size="small" title={<p><img alt="" src={require("@/assets/image/p.png").default} />患者信息</p>} style={{ width: 300, lineHeight: '30px' }}>
              <p>患者姓名：{patientInfo.NAME}</p>
              <p>患者年龄：{patientInfo.EXAM_AGE}</p>
              <p>患者性别：{patientInfo.SEX === "M" ? "男" : "女"}</p>
              <p>申请科室：{patientInfo.REQ_DEPT_NAME}</p>
              <p>患者来源：{patientInfo.PATIENT_SOURCE_NAME}</p>
            </Card>

            <Card className="doubleBox paddingB" size="small" title={<p><img alt="" src={require("@/assets/image/j.png").default} />检查项目</p>} style={{ width: 300, marginTop: '50px' }}>
              <Menu
                selectedKeys={[selectedKeys.key]}
                mode="inline"
                onClick={this.selectMenu}
              >
                {
                  selectedKeys.key ?
                    menuData && menuData.map((item) => {
                      return <Menu.Item key={item.EXAM_UID} >{item.EXAM_CLASS === "ECG" ? "静息心电" : ""}&nbsp;&nbsp;{dataTime}</Menu.Item>
                    })
                    :
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                }
              </Menu>
            </Card>
          </div>
          <Card className="doubleBox paddingB" title={<p><img alt="" src={require("@/assets/image/j.png").default} />心电图报告</p>} style={{ width: "66%", height: 868 }}>
            {
              selectedKeys.key ?
                <img className="imageUrl" src={imageUrl} alt="" style={{ width: "100%" }} />
                : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
            }
          </Card>
        </div>
      </div>
    )
  }
}

export default MedicalReport;